import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";
import "@firebase/analytics";
import "@firebase/functions";

import { getConfig } from "../../../config/app";
import { FirebaseClient } from "./types";

const { region, ...firebaseConfig } = getConfig("firebaseConfig");

const initializeFirebase = (): Promise<FirebaseClient> => {
  return new Promise(resolve => {
    const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
    const db = app.firestore!();
    const auth = firebase.auth!();
    const functions = app.functions(region);
    const storage = firebase.storage!();

    const resolveFirebaseModules = () =>
      resolve({
        auth,
        db,
        functions,
        storage,
        analytics: firebase.analytics()
      });

    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe();

      if (!user) {
        auth.signInAnonymously().then(resolveFirebaseModules);
      } else {
        resolveFirebaseModules();
      }
    });
  });
};

export { initializeFirebase };
